import React, { ReactNode } from 'react';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Quote } from '~/eds/src/components/Quote/Quote';
import { Text } from '~/eds/src/components/Text/Text';
import { useFormatDate } from '~/i18n/hooks/useFormatDate/useFormatDate';

interface Props {
  content: ReactNode;
  quote?: ReactNode;
  dateTime: Date;
}
function ActivityLogItemComponent({ content, quote, dateTime }: Props) {
  const formatDate = useFormatDate();

  return (
    <Layout wrap={true} direction="column" role="listitem">
      <Text>{content}</Text>
      {quote && <Quote wrap>{quote}</Quote>}
      <Text preset="help">{formatDate(dateTime, 'short_datetime')}</Text>
    </Layout>
  );
}

export const ActivityLogItem = React.memo(ActivityLogItemComponent);
